import { useTranslation } from 'react-i18next';

function LearnGrowthTrajectoriesPage() {
  const { t } = useTranslation();
  return <h1>{t('pages.learn_growth_trajectories.title')}</h1>;
}

export default LearnGrowthTrajectoriesPage;
